var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CheckAlterNatePartsUrl, DeclinedJobReasonListUrl, estimateUpsertStandardPartsUrl, getDeclinedStandardJobs, getStandardJobsUrl, standaredJobListUrl } from '../../../../api/url';
import { ArrowDownIcon, ArrowUPIcon, CrossCircleGray, CrossCircleRed } from '../../../../assets/images';
import { InputBox, MuiStack } from '../../../../components';
import { MuiCheckBox } from '../../../../components/atoms/checkBox';
import { MuiIconButton } from '../../../../components/atoms/iconButtonComponent';
import { MuiLoaderButton } from '../../../../components/atoms/loaderButton';
import { MuiSelectComponent } from '../../../../components/atoms/muiSelectComponent';
import SkeletonLoader from '../../../../components/atoms/sketeton';
import { AlternatePartRelations, EModuleSection, isModuleConfig, Module } from '../../../../constants';
import { setSavedTaskDetailsCount, setTaskDetailsDataSaved, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { gray, mobilenoblack } from '../../../../theme/palette';
import { systemColor } from '../../../../theme/systemColor';
import { getSupersadeAlternatePartMessage } from '../../../../utils/utils';
import AlternatePartPopup from './alternatePartPopup';
var RevisedEstimateStandaredJobsComponent = function (props) {
    var _updatedModuleSection;
    var _a = props.callApIStatus, callApIStatus = _a === void 0 ? "false" : _a, isDisabled = props.isDisabled, handleDataFromChild = props.handleDataFromChild, alternatePartConfigState = props.alternatePartConfigState, parentModuleName = props.parentModuleName;
    var dispatch = useAppDispatch();
    var _b = useState([]), standardJobs = _b[0], setStandardJobs = _b[1];
    var _c = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _c.ModuleDetailsGetById, getModuleHeaderCount = _c.getModuleHeaderCount;
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var _d = useState(0), saveCount = _d[0], setSaveCount = _d[1];
    var _e = useState(true), disableSaveButton = _e[0], setDisableSaveButton = _e[1];
    var _f = useState(true), isSkeleton = _f[0], setIsSkeleton = _f[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _g = useState([]), rejectReasonRemarkList = _g[0], setRejectReasonRemarkList = _g[1];
    var _h = useState({}), openSections = _h[0], setOpenSections = _h[1];
    var _j = useParams(), preJobCardDocumentId = _j.preJobCardDocumentId, id = _j.id;
    var isXs = useMediaQuery('(max-width:600px)');
    var _k = useState(false), alternetPartPopupOpen = _k[0], setAlternetPartPopupOpen = _k[1];
    var _l = useState([]), alterNatePartDetails = _l[0], setAlterNatePartDetails = _l[1];
    var _m = useState(null), searchedPart = _m[0], setSearchedPart = _m[1];
    var replacePart = function () {
        var stdJobs = __spreadArray([], standardJobs, true);
        var result = [];
        var alternatePart = alterNatePartDetails.find(function (item) { return item.isChecked; });
        if (alternatePart) {
            for (var _i = 0, stdJobs_1 = stdJobs; _i < stdJobs_1.length; _i++) {
                var stdJobItem = stdJobs_1[_i];
                var PartList = [];
                for (var _a = 0, _b = stdJobItem.StandardServiceAssociation.Part; _a < _b.length; _a++) {
                    var item = _b[_a];
                    if (item.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId)) {
                        PartList.push(_objectSpread(_objectSpread(_objectSpread({}, item), alternatePart), {}, {
                            ChildId: alternatePart.PartId,
                            HasAlternatePart: alternatePart.AssociationName === AlternatePartRelations.TwoWay
                        }));
                    }
                    else {
                        PartList.push(_objectSpread({}, item));
                    }
                }
                var StandardServiceAssociation = {
                    Labour: stdJobItem.StandardServiceAssociation.Labour,
                    Part: PartList
                };
                var standardPartObject = {
                    "StandardServiceGroupName": stdJobItem.StandardServiceGroupName,
                    "StandardServiceId": stdJobItem.StandardServiceId,
                    "isChecked": stdJobItem.isChecked,
                    StandardServiceAssociation: StandardServiceAssociation
                };
                result.push(standardPartObject);
            }
            setStandardJobs(result);
        }
        setAlternetPartPopupOpen(false);
    };
    useEffect(function () {
        if (callApIStatus && ModuleDetailsGetById.data) {
            getStandaredJobList(ModuleDetailsGetById.data);
        }
    }, [callApIStatus, ModuleDetailsGetById]);
    useEffect(function () {
        var fetchDeclinedJobReasons = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _response$payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: DeclinedJobReasonListUrl
                        }))];
                    case 1:
                        response = _a.sent();
                        if (response && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.data && response.payload.success) {
                            setRejectReasonRemarkList(response.payload.data);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchDeclinedJobReasons();
    }, []);
    var getStandaredJobList = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload2, _response$payload3, request, response, _response$payload$val, _response$payload4, mastersItemsList, savedItemsList_1, declinedJobsList_1, finalArray, _loop_1, _i, mastersItemsList_1, masterListItem, sortedFinalArray, newList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        OrganizationId: item === null || item === void 0 ? void 0 : item.OrganizationId,
                        ProductId: item === null || item === void 0 ? void 0 : item.ProductId,
                        VinNo: item === null || item === void 0 ? void 0 : item.VinNo
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'StandaredJobList',
                            url: standaredJobListUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.success && (response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.statusCode) == 200)) return [3 /*break*/, 4];
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    mastersItemsList = (_response$payload$val = response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.value) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.data) !== null && _response$payload$val !== void 0 ? _response$payload$val : [];
                    return [4 /*yield*/, getSavedStandaredJobList()];
                case 2:
                    savedItemsList_1 = _a.sent();
                    return [4 /*yield*/, DeclinedStandardJobs()];
                case 3:
                    declinedJobsList_1 = _a.sent();
                    finalArray = [];
                    _loop_1 = function (masterListItem) {
                        var StandardServiceId = masterListItem.StandardServiceId;
                        var declineItem = declinedJobsList_1.find(function (item) { return item.StandardServiceId === StandardServiceId; });
                        var declineParts = declineItem && declineItem.StandardParts && declineItem.StandardParts.Part ? declineItem.StandardParts.Part : [];
                        var masterParts = masterListItem.StandardServiceAssociation.Part;
                        var newPartArray = [];
                        var _loop_2 = function (masterPartItem) {
                            var declinePartElement = declineParts.find(function (item) { return item.ChildId === masterPartItem.ChildId; });
                            if (declinePartElement) {
                                newPartArray.push(_objectSpread(_objectSpread({}, masterPartItem), {}, {
                                    Price: declinePartElement.Price
                                }));
                            }
                            else {
                                newPartArray.push(masterPartItem);
                            }
                        };
                        for (var _b = 0, masterParts_1 = masterParts; _b < masterParts_1.length; _b++) {
                            var masterPartItem = masterParts_1[_b];
                            _loop_2(masterPartItem);
                        }
                        finalArray.push(_objectSpread(_objectSpread({}, masterListItem), {}, {
                            StandardServiceAssociation: {
                                Labour: [],
                                Part: newPartArray
                            },
                            isDeclined: !!declineItem
                        }));
                    };
                    for (_i = 0, mastersItemsList_1 = mastersItemsList; _i < mastersItemsList_1.length; _i++) {
                        masterListItem = mastersItemsList_1[_i];
                        _loop_1(masterListItem);
                    }
                    sortedFinalArray = finalArray.sort(function (a, b) {
                        return b.isDeclined - a.isDeclined;
                    });
                    newList = sortedFinalArray.map(function (mastersItem) {
                        var exists = savedItemsList_1 === null || savedItemsList_1 === void 0 ? void 0 : savedItemsList_1.find(function (existItem) { return existItem.StandardServiceId === mastersItem.StandardServiceId; });
                        var previousExists = savedItemsList_1 === null || savedItemsList_1 === void 0 ? void 0 : savedItemsList_1.find(function (existItem) { return existItem.StandardServiceId === mastersItem.StandardServiceId; });
                        var Price = declinedJobsList_1 === null || declinedJobsList_1 === void 0 ? void 0 : declinedJobsList_1.find(function (price) { return price.StandardServiceId === mastersItem.StandardServiceId; });
                        var DeclineJob = declinedJobsList_1 === null || declinedJobsList_1 === void 0 ? void 0 : declinedJobsList_1.find(function (declineJob) { return declineJob.StandardServiceId === mastersItem.StandardServiceId; });
                        var Remark = declinedJobsList_1 === null || declinedJobsList_1 === void 0 ? void 0 : declinedJobsList_1.find(function (remark) { return remark.StandardServiceId === mastersItem.StandardServiceId; });
                        return _objectSpread(_objectSpread({}, mastersItem), {}, {
                            isChecked: !!exists,
                            isPreviouslyChecked: !!previousExists,
                            DeclinedJobReasonId: DeclineJob === null || DeclineJob === void 0 ? void 0 : DeclineJob.DeclinedJobReasonId,
                            Remarks: Remark === null || Remark === void 0 ? void 0 : Remark.Remarks,
                            PartPrice: (Price === null || Price === void 0 ? void 0 : Price.PartPrice) || 0,
                            LabourPrice: (Price === null || Price === void 0 ? void 0 : Price.LabourPrice) || 0
                        });
                    });
                    setIsSkeleton(false);
                    setStandardJobs(newList);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getSavedStandaredJobList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload5, _response$payload6, request, response, _response$payload7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        EstimateId: ModuleDetailsGetById.data.ParentId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'SavedStandardJobs',
                            url: getStandardJobsUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && (_response$payload5 = response.payload) !== null && _response$payload5 !== void 0 && (_response$payload5 = _response$payload5.value) !== null && _response$payload5 !== void 0 && _response$payload5.success && (response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.statusCode) == 200) {
                        return [2 /*return*/, response === null || response === void 0 || (_response$payload7 = response.payload) === null || _response$payload7 === void 0 || (_response$payload7 = _response$payload7.value) === null || _response$payload7 === void 0 || (_response$payload7 = _response$payload7.data) === null || _response$payload7 === void 0 ? void 0 : _response$payload7.StandardJob];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var DeclinedStandardJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _ModuleDetailsGetById2, _response$payload8, _response$payload9, request, response, _response$payload10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        ParentId: ModuleDetailsGetById.data.ParentId,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.VinNo,
                        Entity: parentModuleName
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'DeclinedJobs',
                            url: getDeclinedStandardJobs,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && (_response$payload8 = response.payload) !== null && _response$payload8 !== void 0 && (_response$payload8 = _response$payload8.value) !== null && _response$payload8 !== void 0 && _response$payload8.success && (response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.value) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.statusCode) == 200) {
                        return [2 /*return*/, response === null || response === void 0 || (_response$payload10 = response.payload) === null || _response$payload10 === void 0 || (_response$payload10 = _response$payload10.value) === null || _response$payload10 === void 0 ? void 0 : _response$payload10.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCheckboxChange = function (e, listItems) {
        var _list = __spreadArray([], standardJobs, true);
        var finalList = _list.map(function (item) { return item.StandardServiceId === listItems.StandardServiceId ? _objectSpread(_objectSpread({}, item), {}, {
            isChecked: !item.isChecked
        }) : item; });
        setStandardJobs(finalList);
        // handleDataFromChild(false)
        if (!listItems.isChecked) {
            setSaveCount(function (prevCount) { return prevCount + 1; });
        }
        setDisableSaveButton(false);
    };
    var handleSaveClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById3, _response$payload11, _response$payload12, filterList, standardPartArray, standardLabourArray, finalStandardArray, payload, response, sortedList_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    filterList = standardJobs.filter(function (item) { return item.isChecked; });
                    standardPartArray = [];
                    standardLabourArray = [];
                    filterList.forEach(function (value) {
                        var labour = value.StandardServiceAssociation.Labour;
                        var part = value.StandardServiceAssociation.Part;
                        var objLabour = {};
                        var objPart = {};
                        labour.forEach(function (elem) {
                            objLabour['Quantity'] = elem.Quantity;
                            objLabour['SystemName'] = 'Labour';
                            objLabour['ChildId'] = elem.ChildId;
                            objLabour['StandardServiceId'] = elem.StandardServiceId;
                            standardLabourArray.push(_objectSpread({}, objLabour));
                        });
                        part.forEach(function (item) {
                            objPart['Quantity'] = item.Quantity;
                            objPart['SystemName'] = 'Product';
                            objPart['ChildId'] = item.ChildId;
                            objPart['StandardServiceId'] = item.StandardServiceId;
                            objPart['ChildName'] = item.PartName;
                            objPart['ChildCode'] = item.PartCode;
                            standardPartArray.push(_objectSpread({}, objPart));
                        });
                    });
                    finalStandardArray = standardLabourArray.concat(standardPartArray);
                    payload = {};
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        StandardParts: finalStandardArray,
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.RepairTypeId
                    });
                    // payload = { ...payload, EstimateId: ModuleDetailsGetById?.data?.ParentId };
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        EstimateId: preJobCardDocumentId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: estimateUpsertStandardPartsUrl,
                            request: payload
                        }))];
                case 1:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && (_response$payload11 = response.payload) !== null && _response$payload11 !== void 0 && (_response$payload11 = _response$payload11.value) !== null && _response$payload11 !== void 0 && _response$payload11.success && (response === null || response === void 0 || (_response$payload12 = response.payload) === null || _response$payload12 === void 0 || (_response$payload12 = _response$payload12.value) === null || _response$payload12 === void 0 ? void 0 : _response$payload12.statusCode) == 200) {
                        handleDataFromChild(false);
                        dispatch(setSavedTaskDetailsCount({
                            standardJobsCount: saveCount
                        }));
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                                StandardParts: filterList.length
                            })
                        }));
                        dispatch(setTaskDetailsDataSaved(true));
                        setDisableSaveButton(true);
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Standard jobs saved successfully",
                            type: "success"
                        }));
                        sortedList_1 = [];
                        updatedModuleSectionByChannel.map(function (item) {
                            var data = deepClone(item);
                            if (item.Key == EModuleSection.StandardJobs) {
                                if (Module === isModuleConfig.Product) {
                                    data.SectionAttributes[0].MANDATORY = filterList.length > 0 ? true : false;
                                    data.SectionAttributes[0].MANDATORYDefaultValue = filterList.length > 0 ? true : false;
                                }
                            }
                            sortedList_1.push(data);
                        });
                        dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveJobItem = function (item, index) {
        var updatedJobs = standardJobs.map(function (job) {
            if (job.StandardServiceId === item.StandardServiceId) {
                return _objectSpread(_objectSpread({}, job), {}, {
                    isDeclined: !job.isDeclined,
                    isChecked: true
                });
            }
            return job;
        });
        setStandardJobs(updatedJobs);
        setDisableSaveButton(false);
    };
    var toggleSection = function (index) {
        setOpenSections(function (prevSections) {
            var _a;
            return _objectSpread(_objectSpread({}, prevSections), {}, (_a = {},
                _a[index] = !prevSections[index],
                _a));
        });
    };
    var handleAlternatePartClick = function (item, innerIndex, outerIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById4, _ModuleDetailsGetById5, alterNatePartPayload, result, _result$payload$data, alternateParts, alternatePartItem, stdJobs, result_1, _i, stdJobs_2, stdJobItem, PartList, _a, _b, item_1, StandardServiceAssociation, standardPartObject;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    alterNatePartPayload = {
                        "PartId": item.ChildId,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById4 === void 0 ? void 0 : _ModuleDetailsGetById4.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.VinNo
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: CheckAlterNatePartsUrl,
                            request: alterNatePartPayload
                        }))];
                case 2:
                    result = _c.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _c.sent();
                    if (result && result.payload && result.payload.success) {
                        alternateParts = (_result$payload$data = result.payload.data) !== null && _result$payload$data !== void 0 ? _result$payload$data : [];
                        alternatePartItem = alternateParts.find(function (item) { return item.AssociationName === AlternatePartRelations.Superseds; });
                        setSearchedPart(_objectSpread(_objectSpread({}, item), {}, {
                            Name: item.PartName,
                            SkuCode: item.PartCode,
                            isChecked: true
                        }));
                        if (alternatePartItem) {
                            stdJobs = __spreadArray([], standardJobs, true);
                            result_1 = [];
                            for (_i = 0, stdJobs_2 = stdJobs; _i < stdJobs_2.length; _i++) {
                                stdJobItem = stdJobs_2[_i];
                                PartList = [];
                                for (_a = 0, _b = stdJobItem.StandardServiceAssociation.Part; _a < _b.length; _a++) {
                                    item_1 = _b[_a];
                                    if (item_1.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId)) {
                                        PartList.push(_objectSpread(_objectSpread(_objectSpread({}, item_1), alternatePartItem), {}, {
                                            ChildId: alternatePartItem.PartId,
                                            HasAlternatePart: alternatePartItem.AssociationName === AlternatePartRelations.TwoWay
                                        }));
                                    }
                                    else {
                                        PartList.push(_objectSpread({}, item_1));
                                    }
                                }
                                StandardServiceAssociation = {
                                    Labour: stdJobItem.StandardServiceAssociation.Labour,
                                    Part: PartList
                                };
                                standardPartObject = {
                                    "StandardServiceGroupName": stdJobItem.StandardServiceGroupName,
                                    "StandardServiceId": stdJobItem.StandardServiceId,
                                    "isChecked": stdJobItem.isChecked,
                                    StandardServiceAssociation: StandardServiceAssociation
                                };
                                result_1.push(standardPartObject);
                            }
                            setStandardJobs(result_1);
                            dispatch(showNotification({
                                isOpen: true,
                                message: getSupersadeAlternatePartMessage(alternatePartItem.PartName, item.PartName),
                                type: "success"
                            }));
                        }
                        else {
                            setAlterNatePartDetails(alternateParts);
                            setAlternetPartPopupOpen(alternateParts.length > 0);
                            setSearchedPart(_objectSpread(_objectSpread({}, item), {}, {
                                Name: item.PartName,
                                SkuCode: item.PartCode,
                                isChecked: true
                            }));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var isShow = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 || (_updatedModuleSection = updatedModuleSectionByChannel.find(function (f) { return f.Key == 'DECLINED_JOB'; })) === null || _updatedModuleSection === void 0 || (_updatedModuleSection = _updatedModuleSection.Section) === null || _updatedModuleSection === void 0 ? void 0 : _updatedModuleSection.ShowGroupItems;
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: 'column'
    }, standardJobs.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 2,
            key: index,
            marginBottom: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 1
        }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
            id: "service-type-checkbox",
            sx: {
                '& .MuiCheckbox-root': {
                    paddingY: 0,
                    paddingLeft: '4px',
                    paddingRight: '0px',
                    '&.Mui-disabled': {
                        color: item.isExpanded ? '#A8B5C2' : 'disabled'
                    }
                }
            },
            disabled: isDisabled || item.isDeclined || item !== null && item !== void 0 && item.isPreviouslyChecked ? true : false,
            checkBoxValue: item.isChecked || item.isDeclined,
            handleChange: function (e) { return handleCheckboxChange(e, item); }
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4
        }, /*#__PURE__*/ React.createElement(Typography, null, item.StandardServiceGroupName)), isShow && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 1
        }, /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function () { return toggleSection(index); }
        }, /*#__PURE__*/ React.createElement("img", {
            src: openSections[index] ? ArrowUPIcon : ArrowDownIcon,
            alt: "toggle",
            width: "16px",
            height: "16px"
        }))), item.isDeclined && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            textAlign: "right"
        }, /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "remove-job-btn",
            onClick: function () { return handleRemoveJobItem(item, index); }
        }, /*#__PURE__*/ React.createElement("img", {
            src: item.isDeclined ? CrossCircleRed : CrossCircleGray,
            alt: "close"
        })))))), item.StandardServiceAssociation.Part.length > 0 && openSections[index] && item.StandardServiceAssociation.Part.map(function (i, idx) {
            var _i$Price;
            return /*#__PURE__*/ React.createElement(Grid, {
                key: index + 100,
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                marginLeft: 2,
                my: "5px",
                sx: {
                    border: '1px solid #DEE4EB',
                    backgroundColor: '#F4F7FA',
                    borderRadius: 1,
                    padding: "12px 16px !important"
                }
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 8,
                sm: 8,
                md: 8
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                gap: isXs ? "10px" : "0px"
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                md: 6,
                display: 'flex',
                justifyContent: 'space-between',
                pr: '30px'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                sx: {
                    flexDirection: 'column'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5"
            }, i.PartName ? i.PartName : '-'), /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2"
            }, "`$", i.PartCode ? "#".concat(i.PartCode) : '-', "`"), i.HasAlternatePart && !item.isDeclined && alternatePartConfigState["Standard Services"] && /*#__PURE__*/ React.createElement(MuiStack, {
                onClick: function () {
                    handleAlternatePartClick(i, idx, index);
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                style: {
                    cursor: 'pointer',
                    color: systemColor.primary
                }
            }, "Alternate Part"))), /*#__PURE__*/ React.createElement(MuiStack, {
                sx: {
                    border: '1px solid #AFD5FF',
                    borderRadius: '11px',
                    height: '22px',
                    width: '24px',
                    justifyContent: 'center',
                    placeItems: 'center',
                    backgroundColor: "#EEF6FF"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                color: "#3697FF"
            }, 'P'))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                md: 6
            }))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 4,
                sm: 4,
                md: 4
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                gap: isXs ? "10px" : "0px",
                direction: isXs ? 'column-reverse' : 'row'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 4,
                md: 4,
                spacing: 1
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle1",
                color: gray
            }, 'Qty:'), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6",
                color: mobilenoblack
            }, i.Quantity && typeof Number(i.Quantity) === 'number' ? i.Quantity : "-")), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 8,
                md: 8
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                component: "div"
            }, i.Price ? " \u20B9 ".concat((_i$Price = i.Price) === null || _i$Price === void 0 ? void 0 : _i$Price.toFixed(2)) : "-"))))));
        }), item.StandardServiceAssociation.Labour.length > 0 && openSections[index] && item.StandardServiceAssociation.Labour.map(function (i, idx) {
            var _i$Price2;
            return /*#__PURE__*/ React.createElement(Grid, {
                key: index + 100,
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                my: "5px",
                sx: {
                    border: '1px solid #DEE4EB',
                    backgroundColor: '#F4F7FA',
                    borderRadius: 1,
                    padding: "12px 16px !important"
                }
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 8,
                sm: 8,
                md: 8
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                gap: isXs ? "10px" : "0px"
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                md: 6,
                display: 'flex',
                justifyContent: 'space-between',
                pr: '30px'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                sx: {
                    flexDirection: 'column'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5"
            }, i.PartName ? i.PartName : '-'), /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2"
            }, i.PartCode ? i.PartCode : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
                sx: {
                    border: '1px solid #AFD5FF',
                    borderRadius: '11px',
                    height: '22px',
                    width: '24px',
                    justifyContent: 'center',
                    placeItems: 'center',
                    backgroundColor: "#EEF6FF"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                color: "#3697FF"
            }, 'L'))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                md: 6
            }))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 4,
                sm: 4,
                md: 4
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                gap: isXs ? "10px" : "0px",
                direction: isXs ? 'column-reverse' : 'row'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 4,
                md: 4
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle1",
                color: gray
            }, 'Qty:'), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6",
                color: mobilenoblack
            }, i.Quantity && typeof Number(i.Quantity) === 'number' ? i.Quantity : "-")), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 8,
                md: 8
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                component: "div"
            }, i.Price ? " \u20B9 ".concat((_i$Price2 = i.Price) === null || _i$Price2 === void 0 ? void 0 : _i$Price2.toFixed(2)) : "-"))))));
        }), item.isDeclined && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            lg: 12,
            md: 12,
            sm: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2,
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: 'white',
            borderRadius: '8px'
        }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            id: "reject-reason-dropdown",
            margin: 0,
            fullWidth: true,
            options: rejectReasonRemarkList,
            caption: "reason for rejection",
            displayExpr: "DisplayName",
            valueExpr: "id",
            name: "rejectReason",
            value: item.DeclinedJobReasonId || "",
            disabled: true
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: 'white',
            borderRadius: '8px'
        }, /*#__PURE__*/ React.createElement(InputBox, {
            id: "remark-input",
            placeholder: t("ENTER_REMARKS_PLACEHOLDER"),
            fullWidth: true,
            size: "small",
            value: item.Remarks || "",
            disabled: true
        }))))));
    }), isSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        size: "medium",
        loading: loader.isLoaderOpen,
        name: t("Save"),
        id: "NextButton",
        variant: "contained",
        disabled: standardJobs.length == 0 || isDisabled || disableSaveButton,
        onClick: handleSaveClick
    }))), /*#__PURE__*/ React.createElement(AlternatePartPopup, {
        alternetPartPopupOpen: alternetPartPopupOpen,
        setAlternetPartPopupOpen: setAlternetPartPopupOpen,
        replacePart: replacePart,
        searchedPart: searchedPart,
        setSearchedPart: setSearchedPart,
        alterNatePartDetails: alterNatePartDetails,
        setAlterNatePartDetails: setAlterNatePartDetails
    }));
};
export default RevisedEstimateStandaredJobsComponent;
